/**
 * Toast notification component using Sonner
 *
 * Provides success, error, and info toasts with Eventus styling.
 */

import { Toaster as SonnerToaster } from 'sonner'

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        classNames: {
          toast: 'bg-card border border-border shadow-lg rounded-lg',
          title: 'text-card-foreground font-medium',
          description: 'text-muted-foreground text-sm',
          success: 'border-l-4 border-l-green-500',
          error: 'border-l-4 border-l-red-500',
          info: 'border-l-4 border-l-[var(--eventus-teal)]',
        },
      }}
    />
  )
}

// Re-export toast function for convenience
export { toast } from 'sonner'
